// extracted by mini-css-extract-plugin
module.exports = {"nameplateImage":"HeroContent_nameplateImage__Fvaur","alternativeNameplate":"HeroContent_alternativeNameplate__9s7R6"};